var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-circular',{attrs:{"id":"loading_spinner","indeterminate":"","size":"64","color":"primary"}})}
var staticRenderFns = []

export { render, staticRenderFns }